import { inject, Injectable, signal } from '@angular/core';

import { IntegrationEventName } from '@ppg/core/enums';

import { MobileAppViewService } from '../mobile-app-view/mobile-app-view.service';

@Injectable({
  providedIn: 'root',
})
export class CartStateService {
  readonly mobileAppViewService = inject(MobileAppViewService);

  readonly #cartItemsTotalQuantity = signal(0);
  readonly cartItemsTotalQuantity = this.#cartItemsTotalQuantity.asReadonly();

  addQuantity(quantity: number) {
    this.changeQuantity(this.cartItemsTotalQuantity() + quantity);
  }

  changeQuantity(quantity: number) {
    this.#cartItemsTotalQuantity.set(quantity);
    this.mobileAppViewService.invokeCSharpAction(`${IntegrationEventName.CartItemsQuantity}${quantity}`);
  }
}
